export default __webpack_public_path__ + "static/media/coming-soon.f5579742.png";